import { styled } from '@mui/material';
import { Colors } from 'library';
import { ITeacher } from 'models';
import React from 'react';
import { WorkerAvatar } from './WorkerAvatar';

export default function TeacherCardBaseHeader({
    worker,
    leftHeaderComponent,
    rightHeaderComponent,
    middleHeaderComponent,
    color,
    sectionWidths,
}: {
    worker: ITeacher;
    middleHeaderComponent?: React.ReactNode;
    leftHeaderComponent?: React.ReactNode;
    rightHeaderComponent?: React.ReactNode;
    color?: string;
    sectionWidths?: {
        left?: string;
        middle?: string;
        right?: string;
    };
}) {
    return (
        <Header color={color}>
            <Row>
                <SideSection justify="center" width={sectionWidths?.left}>
                    {leftHeaderComponent}
                </SideSection>
                <MiddleSection width={sectionWidths?.middle}>
                    {middleHeaderComponent || <WorkerAvatar src={worker.pictureUrl} width={100} height={100} />}
                </MiddleSection>
                <SideSection justify="flex-end" width={sectionWidths?.right}>
                    {rightHeaderComponent}
                </SideSection>
            </Row>
        </Header>
    );
}

const Header = styled('div')(({ color }: { color?: string }) => ({
    background: `linear-gradient(180deg, ${color || Colors.terraCotta} calc(50% + 10px), transparent calc(50% + 10px))`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
}));

const SideSection = styled('div')(({ justify, width }: { justify: string; width?: string }) => ({
    alignItems: 'center',
    display: 'flex',
    height: 'calc(50% + 10px)',
    justifyContent: justify,
    width: width || '33%',
    position: 'relative',
}));

const MiddleSection = styled('div')(({ width }: { width?: string }) => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: width || '34%',
}));

const Row = styled('div')({
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    width: '100%',
});
